import { appPath } from './paths';

export const BUSINESS_OVERVIEW_VIEW_PERMISSION = 'business-overview.view';
export const TASK_DASHBOARD_VIEW_PERMISSION = 'tasks.dashboard.view';

/** Default landing path after sign-in when no explicit deep link is provided. */
export function getDefaultAppPath(hasPermission: (permission: string) => boolean): string {
  if (hasPermission(BUSINESS_OVERVIEW_VIEW_PERMISSION)) {
    return appPath();
  }

  if (hasPermission(TASK_DASHBOARD_VIEW_PERMISSION)) {
    return appPath('/task-dashboard');
  }

  return appPath('/unauthorized');
}
